// extracted by mini-css-extract-plugin
export default {"mealTable":"wwoklWhULLrlWNqrz_Qp"};